import { useMutation } from '@tanstack/react-query';

import { otpAuthAPI } from '../api/authAPI';
import { toOtpAuthError } from '../libs/otpAuthError';
import { custonSooner } from '../../../components/CustopmSooner';
import { captureApiError } from '../../../lib/sentry-utils';
import { toApiPhone } from '../../../utils/formatPhone';

/**
 * Отправка кода по СМС.
 *
 * Повторов нет намеренно: у эндпоинта ограничение в 120 секунд между кодами и
 * десять кодов в час на номер, так что автоматический ретрай только сожжёт
 * лимит и вернёт `resend_too_soon`.
 */
export const useSendOtp = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (phone: string) => {
      const res = await otpAuthAPI.sendOtp(toApiPhone(phone));
      return res.data.data;
    },
    onError: error => {
      captureApiError(error, '/client/otp-auth/send-otp', 'POST');
      custonSooner.error(toOtpAuthError(error).message);
    },
  });

  return {
    sendOtp: mutateAsync,
    isPending,
  };
};
